export default "__VITE_ASSET__WREaQg6M__"